import { render } from "./SearchPatient.vue?vue&type=template&id=6c0828be&scoped=true&lang=pug"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"

import "./SearchPatient.vue?vue&type=style&index=0&id=6c0828be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0828be"]])

export default __exports__